module.exports = __webpack_public_path__ + "static/img/cont2701.a215038.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2701.jpg
// module id = 5+9S
// module chunks = 0